import { NAME_AFTER_RE, normalizeGeneratedArtifactPrompt } from './generatedArtifactAssistantPayloadPatterns.js'

/**
 * @param {string} trimmed
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').ArtifactKind} kind
 */
function extractRawName(trimmed) {
  const normalized = normalizeGeneratedArtifactPrompt(trimmed)
  const nameMatch = normalized.match(NAME_AFTER_RE)
  return nameMatch?.[1]?.trim().replace(/[.!?]+$/, '').trim() ?? ''
}

function resolveFileName(rawName, defaultBase, defaultExt) {
  if (rawName && rawName.length > 0) {
    return rawName.includes('.') ? rawName : `${rawName}.${defaultExt}`
  }
  return `${defaultBase}.${defaultExt}`
}

/**
 * @param {string} trimmed
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').ArtifactKind} kind
 */
export function resolveGeneratedArtifactDetails(trimmed, kind) {
  const rawName = extractRawName(trimmed)

  if (kind === 'spreadsheet') {
    return {
      kind,
      fileName: resolveFileName(rawName, 'Untitled Workbook', 'xlsx'),
      displayTitle: rawName || 'Untitled Workbook',
      description: 'Spreadsheet · Ready to edit',
      leadLine: "Sure, I'll create that spreadsheet for you.",
    }
  }

  if (kind === 'html') {
    const displayTitle = rawName || 'Untitled App'
    return {
      kind,
      fileName: rawName ? (rawName.includes('.') ? rawName : `${rawName}.html`) : 'index.html',
      displayTitle,
      description: 'Web app · Generated preview',
      leadLine: "Sure, I'll create that app for you.",
    }
  }

  return {
    kind,
    fileName: resolveFileName(rawName, 'Untitled Document', 'docx'),
    displayTitle: rawName || 'Untitled Document',
    description: 'Blank document · Ready to edit',
    leadLine: "Sure, I'll create that document for you.",
  }
}
